class RelatedProductsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    setVariables() {
      this.sliderElement = this.querySelector('[data-slider]');
      this.slides = this.sliderElement?.querySelectorAll('[data-slider-item]') || [];
      this.prevButton = this.querySelector('[data-slider-prev]')
      this.nextButton = this.querySelector('[data-slider-next]')
      this.addToCartButton = this.querySelector('.related-product__button .button');
      this.totalPriceElement = this.querySelector('.related-product__total-price-value');
      this.checkboxes = this.querySelectorAll('.related-product__checkbox');
      this.miniCart = document.querySelector('mini-cart');
    }

    connectedCallback() {
      this.setVariables()
      document.addEventListener('DOMContentLoaded', () => this.initSlider());
      window.addEventListener('resize', () => this.initSlider());
      this.initRelatedProducts();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initRelatedProducts() {
      // Add event listeners to checkboxes
      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          this.updateTotalPrice();
        });
      });

      // Add event listener to add to cart button
      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.addSelectedProductsToCart();
        });
      }

      // Initialize total price
      this.updateTotalPrice();
    }

    updateTotalPrice() {
      let totalPrice = 0;
      let selectedCount = 0;

      this.checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const productCard = checkbox.closest('.related-product');

          // Try to get sale price first, then regular price
          let priceElement = productCard.querySelector('.price__sale .price-item--sale');
          if (!priceElement) {
            priceElement = productCard.querySelector('.price__regular .price-item--regular');
          }

          if (priceElement) {
            const priceText = priceElement.textContent.trim();
            // Remove currency symbols and parse price
            const price = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.'));
            if (!isNaN(price)) {
              totalPrice += price;
              selectedCount++;
            }
          }
        }
      });

      if (this.totalPriceElement) {
        if (selectedCount > 0) {
          // Format price with currency symbol
          const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(totalPrice);
          this.totalPriceElement.textContent = formattedPrice;
          this.addToCartButton.disabled = false;
        } else {
          this.totalPriceElement.textContent = '';
          this.addToCartButton.disabled = true;
        }
      }
    }

    addSelectedProductsToCart() {
      const selectedProducts = [];

      this.checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          selectedProducts.push({
            id: parseInt(checkbox.value, 10),
            quantity: 1
          });
        }
      });

      if (selectedProducts.length === 0) {
        return;
      }

      // Disable button and show loading state
      this.addToCartButton.setAttribute('disabled', true);
      this.addToCartButton.classList.add('loading');

      const sections = this.miniCart
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [];

      const body = JSON.stringify({
        items: selectedProducts,
        sections: sections,
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, {
        ...fetchConfig("javascript"),
        body
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((parsedState) => {
          if (this.miniCart) {
            this.miniCart.renderContents(parsedState);
          }

          if (typeof GTMDataLayer !== 'undefined' && parsedState?.items?.length) {
            parsedState.items.forEach(addedItem => {
              const item = {
                item_name: addedItem.product_title,
                item_id: addedItem.product_id.toString(),
                price: addedItem.price / 100,
                item_brand: addedItem.vendor || '',
                item_category: addedItem.product_type || '',
                item_variant_id: addedItem.variant_id.toString(),
                item_variant: addedItem.variant_title || '',
                quantity: addedItem.quantity || 1
              };
              GTMDataLayer.addToCart(item, (addedItem.price * addedItem.quantity) / 100, window.shopSettings?.isoCode || 'USD');
            })
          }

          // Uncheck all checkboxes after successful addition
          this.checkboxes.forEach(checkbox => {
            if (checkbox.checked && !checkbox.disabled) {
              checkbox.checked = false;
            }
          });

          // Update total price
          this.updateTotalPrice();
        })
        .catch((e) => {
          console.error('Error adding products to cart:', e);
        })
        .finally(() => {
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.removeAttribute('disabled');
        });
    }

    initSlider() {
      this.destroySlider();
      if (!this.sliderElement) return;

      this.flickity = new Flickity(this.sliderElement, {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        wrapAround: false,
        groupCells: true,
        contain: true
      });

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.flickity.previous());
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.flickity.next());

      this.validateCarousel(0)
      this.flickity.on('change', (index) => {
        this.validateCarousel(index)
      })
    }

    validateCarousel(index) {
      if (index == 0) {
        this.prevButton?.classList.add('disabled')
      } else {
        this.prevButton?.classList.remove('disabled')
      }

      if (index >= this.flickity.slides.length - 1) {
        this.nextButton?.classList.add('disabled')
      } else {
        this.nextButton?.classList.remove('disabled')
      }
    }

    destroySlider() {
      if (this.flickity) {
        this.flickity.destroy();
        this.flickity = null;
      }

      if (this.sliderElement) this.sliderElement.classList.remove('flickity-enabled', 'flickity-rtl');
    }
  }

  customElements.define('related-products-carousel', RelatedProductsCarousel);
